export const formatDate = (dateStr) => {
    if (!dateStr) return '--';
    // 将连字符替换为斜杠，iOS 能更好地支持斜杠格式
    const safeDateStr = dateStr.replace(/-/g, '/');
    const date = new Date(safeDateStr);
    
    // 增加日期有效性检查
    if (isNaN(date.getTime())) {
        return '--';
    }

    const yy = date.getFullYear().toString().slice(-2);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    return `${yy}/${mm}/${dd} ${hh}:${mi}:${ss}`;
}